import React from 'react';
import { GiftIcon } from 'lucide-react';
import { PackSlider } from './PackSlider';
import { pricing } from '../data/offer';
export function BonusSection() {
  return <section aria-labelledby="bonos-titulo" className="w-full bg-cream-50" data-id="element-29" data-mp="1oi811bi6d428">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 sm:py-20 lg:py-24" data-id="element-30" data-mp="22ety4ka7uovl">
        <div className="max-w-2xl" data-id="element-31" data-mp="1yeji0espmi30">
          <p className="flex items-center gap-2 font-display text-[11px] font-bold uppercase tracking-[0.2em] text-moss-600 sm:text-xs sm:tracking-[0.22em]" data-id="element-32" data-mp="1yc6zo0j1i5pf">
            <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-33" data-mp="15qnr5qptnke5" />
            El programa + 5 bonos gratis
          </p>
          <h2 id="bonos-titulo" className="mt-3 font-display text-2xl font-extrabold leading-tight tracking-tight text-forest-900 sm:mt-5 sm:text-4xl" data-id="element-34" data-mp="1ji287s065bik">
            Todo lo que te llevás hoy con el MegaPack Hábitos
          </h2>
          <p className="mt-3 text-[15px] text-forest-800/75 sm:mt-4 sm:text-lg" data-id="element-35" data-mp="mxtj7gqm8sjf">
            El desafío de 21 días más cinco recursos para acelerar tu proceso y mantener el ritmo
            cuando el entusiasmo inicial baja.
          </p>
        </div>

        <div className="mt-7 sm:mt-10" data-id="element-36" data-mp="2eothdykjaev0">
          <PackSlider data-id="element-37" data-mp="2jhmogt3h5za9" />
        </div>

        <div className="mt-8 border-t-2 border-forest-900 pt-6 sm:mt-12 sm:pt-8" data-id="element-38" data-mp="2jio6ximtlo20">
          <p className="font-display text-xl font-extrabold leading-snug tracking-tight text-forest-900 sm:text-3xl" data-id="element-39" data-mp="2ogg00fz7bg7s">
            Los 5 bonos tienen un valor total de{' '}
            <span className="line-through decoration-clay-500 decoration-2" data-id="element-40" data-mp="1vrik2jigpvi7">
              {pricing.bonusValue}
            </span>
          </p>
          <p className="mt-2 text-[15px] text-forest-800/80 sm:mt-3 sm:text-lg" data-id="element-41" data-mp="20thn1saaiqem">
            Y hoy te los llevás completamente gratis con tu MegaPack Hábitos.
          </p>
        </div>
      </div>
    </section>;
}